import React, { useEffect, useState } from 'react';
import { Input, Button, Row, Col, Form, message } from 'antd';

  const TATModalBody = ({ defaults, callback }) => {
  const [TATHrsValue, setTATHrsValue] = useState(0);
  const [TATMinsValue, setTATMinsValue] = useState(0);
  const [tathrs, setTathrs] = useState(0);
  const [tatmins, setTatmins] = useState(0);

  useEffect(() => {
    if (defaults > 0) {
      const [rhours, rminutes] = timeConvert(defaults);
      setTATHrsValue(rhours);
      setTATMinsValue(rminutes);
    } else {
      setTATHrsValue(0);
      setTATMinsValue(0);
    }
  }, [defaults]);

  const timeConvert = (n) => {
    const hours = Math.floor(n / 60);
    const minutes = n % 60;
    return [hours, minutes];
  };

  const handleHrsChange = (e) => {
    const value = Number(e.target.value);
    if (value < 0) {
      message.warning("Please enter a value above zero");
    } else {
      setTathrs(value);
      setTATHrsValue(value);
    }
  };

  const handleMinsChange = (e) => {
    const value = Number(e.target.value);
    if (value < 0) {
      message.warning("Please enter a value above zero");
    } else if (value >= 60) {
      setTATHrsValue(prev => prev + 1);
      setTATMinsValue(0);
      setTathrs(prev => prev + 1);
      setTatmins(0);
    } else {
      setTatmins(value);
      setTATMinsValue(value);
    }
  };

  const handleSubmit = () => {
    const TAT = (TATHrsValue * 60) + TATMinsValue;
    const originalTATValue = `${TATHrsValue} Hrs`;
    const originalMinsValue = `${TATMinsValue} Mins`;
    callback(TAT, `${originalTATValue} ${originalMinsValue}`);
  };

  return (
    <div className="container">
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Hours">
            <Input
              type="number"
              value={TATHrsValue}
              onChange={handleHrsChange}
              placeholder="Hrs"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Minutes">
            <Input
              type="number"
              value={TATMinsValue}
              onChange={handleMinsChange}
              placeholder="Mins"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="center" style={{ paddingTop: 10 }}>
        <Col span={6}>
          <Button
            className='custom-btn'
            style={{ width: "100%", backgroundColor:"#29b6f6" , color:"white" }}
            onClick={handleSubmit}
          >
            OK
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default TATModalBody;
